<template>
  <div class="list-box" style="position: relative">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="付款账户、付款账号"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="到账日期"
          end-placeholder="到账日期"
          value-format="YYYY-MM-DD"
          @change="
            (value) => {
              if (value)
                state.params.received_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.received_date;
          "
        />
        <el-select
          v-model="state.bank_account_ids"
          style="width: 350px"
          placeholder="到账银行"
          multiple
          collapse-tags
          collapse-tags-tooltip
        >
          <el-option
            v-for="item in state.bankaccount_data"
            :key="item"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-checkbox
          v-model="state.params.is_more"
          :true-value="1"
          :false-value="0"
          label="显示更多"
          size="large"
          title="勾选显示未匹配客户的到款记录"
          @change="onLoad"
        />
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
      <text
        v-if="state.selectList?.filter((w) => w != -1)?.length > 0"
        style="margin-right: 10px; color: #1e90ff; line-height: 40px"
      >
        已选
        <strong style="color: #f00">{{
          state.selectList?.filter((w) => w != -1)?.length
        }}</strong>
        条到款记录
      </text>
      <el-button
        type="warning"
        :icon="Select"
        link
        @click="state.showAdd = true"
        :disabled="!state.selectList || state.selectList?.length <= 0"
        >批量认领
      </el-button>
    </ul>
    <ul class="list-table">
      <el-checkbox-group
        v-model="state.selectList"
        style="flex: 1; display: flex; flex-direction: column; overflow: hidden"
      >
        <el-table
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
        >
          <el-table-column width="55" fixed>
            <template #header>
              <el-checkbox :value="-1" @change="onSelect($event, -1)" />
            </template>
            <template #default="{ row }">
              <el-checkbox
                :value="row.id"
                @change="onSelect($event, row)"
                :disabled="row.collected_status == 2"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="到款时间"
            prop="received_time"
            sortable="received_time"
            width="120"
            :formatter="$tab_TextFormat"
            fixed
          />
          <el-table-column
            label="付款人"
            prop="payment_name"
            :formatter="$tab_TextFormat"
            min-width="160"
          />
          <el-table-column
            label="金额"
            prop="received_amount"
            align="right"
            :formatter="$tab_PriceFormat"
            min-width="140"
          />
          <el-table-column
            label="实际到账金额/手续费"
            align="right"
            :formatter="
              (row) =>
                $tab_GroupFormat(
                  $priceFormat(row.real_received_amount),
                  $priceFormat(row.service_fee),
                )
            "
            min-width="160"
          />
          <el-table-column
            label="已认领/未认领金额"
            min-width="160"
            align="right"
          >
            <template #default="{ row }">
              <div style="display: flex; justify-content: flex-end">
                <c_tabgroup
                  :value1="$priceFormat(row.collected_amount)"
                  style="
                    align-items: flex-end;
                    display: flex;
                    flex-direction: column;
                  "
                >
                  <template #bottom>
                    <c_money
                      style="font-weight: 600"
                      :value="row.uncollected_amount"
                    />
                  </template>
                </c_tabgroup>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态/ID" sortable="id" width="120">
            <template #default="{ row }">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  width: fit-content;
                "
              >
                <c_tabgroup :value2="row.id">
                  <template #top>
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        column-gap: 5px;
                      "
                    >
                      <el-tag
                        type="primary"
                        size="small"
                        title="该到款记录为合并后的到款记录"
                        style="cursor: pointer"
                        v-if="row.is_merge"
                        >合
                      </el-tag>
                      <c_status
                        arr-name="bankReceived_collected_status"
                        :value="row.collected_status"
                      />
                    </div>
                  </template>
                </c_tabgroup>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="匹配客户"
            prop="customer_name"
            width="200"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="到账银行"
            :formatter="
              (row) =>
                $tab_GroupFormat(
                  row.bank_account?.account,
                  row.bank_account?.opening_bank || '',
                )
            "
            min-width="220"
          />
          <el-table-column
            label="认领客户"
            prop="customer_name"
            :formatter="$tab_TextFormat"
            min-width="220"
          />
          <el-table-column
            label="付款银行"
            :formatter="
              (row) =>
                $tab_GroupFormat(row.payment_account, row.payment_bank || '')
            "
            min-width="220"
          />
          <el-table-column label="摘要信息/认领明细" min-width="400">
            <template #default="{ row }">
              <div>
                <ul>
                  {{
                    row.customer_name
                  }}
                </ul>
                <ul
                  v-if="row.collected_amount_detail?.collected"
                  style="
                    color: #a2a2a2;
                    font-size: var(--tab-group-second-font-size);
                  "
                  v-html="
                    Object.keys(row.collected_amount_detail?.collected)
                      .map(
                        (key) =>
                          `${key}: <text style='color:#ffa500;margin-right:5px'>${$priceFormat(
                            row.collected_amount_detail?.collected[key],
                          )}</text>`,
                      )
                      .join(' ')
                  "
                ></ul>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
            className="tabBtn"
          >
            <template #default="{ row }">
              <el-button
                type="primary"
                link
                icon="Select"
                @click="
                  $store.commit('openMenu', {
                    path: 'PayrollBankCollectedDetail',
                    title: '银行到账认领',
                    refresh: true,
                    data: {
                      id: row.id,
                      payroll_id: props.payroll_id,
                      payroll_order_id: props.payroll_order_id,
                      customer_id: props.customer_id,
                    },
                  })
                "
              >
                认领
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAdd"
        title="批量认领"
        @close="state.showAdd = false"
      >
        <c_PayrollBankCollectedAddBatch
          @close="
            state.showAdd = false;
            onLoad();
          "
          :ids="state.selectList.filter((w) => w !== -1)"
          :customer_id="props.customer_id"
          :payroll_id="props.payroll_id"
          @confirm="onAddConfirm"
        ></c_PayrollBankCollectedAddBatch>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { payrollemployee_bankreceived } from "@/http/payrollemployee";
import { data_bankaccount_select } from "@/http/data";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    merge_status: 0,
  };
}
export default {
  props: {
    customer_id: Number,
    payroll_id: Number,
    payroll_order_id: String,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.customer_id = props.customer_id;
      state.params.payroll_id = props.payroll_id;
      onLoadBankAcount();
      onLoad();
    });

    const onLoadBankAcount = () => {
      data_bankaccount_select().then((res) => {
        if (res.status == 200) {
          state.bankaccount_data = res.data.data?.list;
        }
      });
    };

    const onLoad = () => {
      delete state.tableData;

      if (state.bank_account_ids?.length > 0)
        state.params.bank_account_id = state.bank_account_ids.join(",");
      payrollemployee_bankreceived(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;

          const ids = list.map((m) => m.id);
          if (state.selectList?.length > 0) {
            if (ids.every((e) => state.selectList?.includes(e))) {
              if (!state.selectList.includes(-1)) state.selectList.push(-1);
            } else state.selectList = state.selectList.filter((w) => w !== -1);
          }
        }
      });
    };

    const onDateChange = (value) => {
      if (value) state.params.received_date = value[0] + " - " + value[1];
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onSelect = (checked, item) => {
      if (item == -1) {
        if (checked) {
          state.selectList = [
            ...state.selectList,
            ...state.tableData
              .filter(
                (w) =>
                  w.collected_status != 2 && !state.selectList.includes(w.id),
              )
              .map((m) => m.id),
          ];
        } else {
          state.selectList = state.selectList.filter(
            (w) => !state.tableData.map((m) => m.id).includes(w),
          );
        }
      }
    };

    const onAddConfirm = () => {
      state.selectList = [];
      state.showAdd = false;
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDateChange,
      props,
      onSelect,
      onAddConfirm,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
